import React from 'react';
import { SearchableSelect } from '../../../common/components/UI/Select';

 
import { getRequestTypeList } from '../../Enums/Helpers/LabellingHelper';

/**
 * @param {ReturnType<typeof getRequestTypeList>} list
 * @param {number} id
 * @param {string} key
 * @returns {string}
 */
export const findItem = (list, id, key) => {
    if (list.length > 0) {
        let auxFind = list.find(item => item[key] === id)
        return typeof auxFind === 'undefined' ? '' : auxFind
    }
    return ''
}
export const generateInputs = (labelTypo, placeholder, value, list, target, disabled = false, error = false, note = '', handleChange) => (
    <div>
        {labelTypo && <div className="labelWrapper"><span style={{ margin: 0, fontFamily: '"SF Pro Display","Roboto","Helvetica","Arial",sans-serif', fontWeight: 400, fontSize: '1rem', lineHeight: 1.5, letterSpacing: '0.00938em' }}>{labelTypo}</span></div>}
        <SearchableSelect
            options={list ?? []}
            value={value?.value !== undefined ? value : null}
            onChange={(selected) => handleChange(target, selected)}
            placeholder={placeholder}
            disabled={disabled}
            error={error}
        />
        {note && <span style={{ color: '#A9A9A9', fontSize: '0.75rem', textAlign: 'left', display: 'block' }}>{note}</span>}
    </div>
)
